import Button from '@/components/UI/Button';

export const LegalDisclosure = ({ startApplicationHandler }: { startApplicationHandler: () => void }) => {
  return (
    <>
      <div className=''>
        <h2 className='mt-0 text-primaryColor-normal border-l-4 border-green-500 px-6 py-2'>Legal Disclaimer</h2>
      </div>
      <section className='px-6 space-y-4'>
        <p>
          By accessing this site, you acknowledge that your use is subject to  Enterprise Community Partners’ 
          <a
            href='https://www.enterprisecommunity.org/terms-of-use-privacy-policy'
            target='_blank'
            rel='noreferrer'
            className='underline text-blue-500 cursor-pointer'
          >
            terms and conditions and privacy policy
          </a>
          .By using this guide, you agree that this guide in no way should be construed as rendering any legal, accounting or any other
          project specific advice. You also agree that this guide is provided on an "as-is" and "as available" basis. We, our employees,
          officers, trustees, and agents and third party content providers assume no responsibility for, and expressly disclaim any
          liability resulting from, the use of any material contained in this guide.
        </p>
        <p>
          Enterprise makes no representations or warranties of any kind, express or implied, with respect to the operation of this guide or
          the information, content, materials, or products included. The use of this guide is at your sole risk. To the full extent
          permissible by applicable law, we disclaim all warranties, express or implied, including, but not limited to, implied warranties
          of merchantability and fitness for a particular purpose. We do not warrant that this guide is free of viruses or other harmful
          components. We will not be liable for any damages of any kind arising from the use of the guide, including, but not limited to
          direct, indirect, incidental, punitive, and consequential damages.
        </p>

        <p>
          You will indemnify and hold us harmless from and against any loss of data or profit, cost, liability or damages, including
          attorneys’ fees, for which we become liable arising from or relating to any claim relating to your use of the guide, including but
          not limited to any claim brought by a third party alleging that your use of the guide in breach of these Terms of Use, infringes
          or misappropriates the rights of a third party or violates applicable law. 
        </p>
        <p>
          Certain state laws do not allow limitations on implied warranties or the exclusion or limitation of certain damages. If these laws
          apply to you, some or all of the above disclaimers, exclusions, or limitations may not apply to you, and you might have additional
          rights. 
        </p>
        <p className='my-5 italic'>
          Your use of this site is governed by the laws of the State of Maryland, exclusive of its conflicts of law rules and federal law.
          You agree that any suit, action or proceeding instituted with respect to any actions resulting from the use of this Site will be
          brought in any state or federal court located in the State of Maryland and you consent to the personal jurisdiction of such
          courts. You irrevocably waive any objection to, and any right of immunity from, the jurisdiction of such courts or the execution
          of judgments resulting there from, on the grounds of venue or the convenience of the forum. 
        </p>
        <div className='flex justify-end pt-4'>
          <Button label='Accept and Continue' btnStyle='btn-primary' btnType='button' onClick={startApplicationHandler} />
        </div>
      </section>
    </>
  );
};
